import { CampaignType, TYPES } from '../../../../constants/marketingCampaign'
import { BuildFormValuesContext } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { BNGM_SCOPE, BNGM_TARGET_TYPE, BuyNGetMRuleState } from './types'

export function buildBuyNGetMFormValues(
	ctx: BuildFormValuesContext<BuyNGetMRuleState>,
): Record<string, unknown> {
	const { rule, confirmation, selectedShopIds, campaignMeta, marketingCampaignKey } = ctx

	const base: Record<string, unknown> = {
		startDate: confirmation.startDate,
		startTime: confirmation.startTime,
		discount: rule.discountPercent,
		threshold: null,
		type: CampaignType.BUY_N_GET_M_CHEAPEST_AT_DISCOUNT,
		shopIds: selectedShopIds,
		valueType: campaignMeta.valueType,
		config: {
			target:
				rule.scopeType === BNGM_SCOPE.PRODUCTS
					? BNGM_TARGET_TYPE.PRODUCTS
					: BNGM_TARGET_TYPE.OPTION_LIST,
			products: rule.scopeType === BNGM_SCOPE.PRODUCTS ? rule.products : undefined,
			optionListKey:
				rule.scopeType === BNGM_SCOPE.OPTIONS
					? rule.selectedOptionListKey
					: undefined,
			numProductsPaid: rule.numProductsPaid,
			numProductsDiscounted: rule.numProductsDiscounted,
			discount: { type: TYPES.PERCENTAGE, value: rule.discountPercent },
		},
		hasLimit: confirmation.hasLimit,
		limit: confirmation.hasLimit ? confirmation.limit : null,
		marketingCampaignKey,
		orderTypes: confirmation.orderTypes,
		isPermanent: confirmation.isPermanent,
	}

	if (!confirmation.isPermanent) {
		base.endDate = confirmation.endDate
		base.endTime = confirmation.endTime
	}

	return base
}
